/*
 *  -----------------------------------------------------------------------
 *    <copyright file="lead-visit-id-field/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import SelectWithCategories from '@components/core/select-with-categories';
import { useTranslation } from '@hooks/index';
import Constants from '@utils/constants';
// eslint-disable-next-line max-len
import { StudyVisitScheduleFields_StudySubjectVisitScheduleTemplate_visits_StudySubjectVisit as StudyVisitScheduleFields_StudySubjectVisit } from '@queries/generated/fragments.generated';

interface LeadVisitIdFieldInterface {
    visits: StudyVisitScheduleFields_StudySubjectVisit[];
    currentVisit?: StudyVisitScheduleFields_StudySubjectVisit;
    onChange(fieldName?: string): void;
    currentState: string;
    error?: string;
    disabled?: boolean;
}
const LeadVisitIdField = ({
    visits,
    currentVisit,
    onChange,
    currentState,
    error,
    disabled,
}: LeadVisitIdFieldInterface) => {
    const { t } = useTranslation();

    const makeLeadVisitsIdOptions = () => {
        const leadVisitsIDArray = visits?.map((visit: StudyVisitScheduleFields_StudySubjectVisit) => ({
            id: visit?.visitId,
            text: `${visit?.visitId} | ${visit?.visitName}`,
        }));
        if (currentVisit) {
            const thisVisitIdOptionIndex: number = leadVisitsIDArray?.findIndex(
                (v: { id: string | null; text: string }) => currentVisit.visitId === v.id,
            );

            if (thisVisitIdOptionIndex >= 0) {
                leadVisitsIDArray.splice(thisVisitIdOptionIndex, 1);
            }
        }
        leadVisitsIDArray?.unshift({
            id: Constants.ObjectId.Empty,
            text: `${t('admin:selectLeadVisitIdLabel')}`,
        });

        return leadVisitsIDArray;
    };

    return (
        <SelectWithCategories
            showWarning={false}
            searchable
            fieldSelect="leadVisitId"
            onChange={onChange}
            label={t('admin:leadVisitId')}
            filterable={false}
            labelField={t('admin:leadVisitId')}
            dataArray={makeLeadVisitsIdOptions() ?? []}
            customId="add-lead-visit-id"
            currentState={currentState}
            error={error}
            disabled={disabled}
        />
    );
};

export default LeadVisitIdField;
